/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AttendanceTemperatureSwitch.vue?vue&type=template&id=0515f3f0&scoped=true&"
import script from "./AttendanceTemperatureSwitch.vue?vue&type=script&setup=true&lang=js&"
export * from "./AttendanceTemperatureSwitch.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AttendanceTemperatureSwitch.vue?vue&type=style&index=0&id=0515f3f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0515f3f0",
  null
  
)

export default component.exports